// extracted by mini-css-extract-plugin
var _1 = "SettingsModal__backdrop--D42yl ModalGeneral__backdrop--gxZiG";
var _2 = "SettingsModal__button--uRSoH";
var _3 = "SettingsModal__header--j7uru fontSize__settingsModalHeader--A4YfT";
var _4 = "SettingsModal__main--jogCd CoreGeneral__robotoSlab--X8lgW";
var _5 = "SettingsModal__section--tMt65";
var _6 = "SettingsModal__slider--ZMP6k";
var _7 = "SettingsModal__sliderContainer--ipLTi";
var _8 = "SettingsModal__title--ncPQV fontSize__settingsModalTitle--loi0H";
var _9 = "SettingsModal__volumeIcon--bYX9a";
export { _1 as "backdrop", _2 as "button", _3 as "header", _4 as "main", _5 as "section", _6 as "slider", _7 as "sliderContainer", _8 as "title", _9 as "volumeIcon" }
